var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-body"},[_c('navbar'),_c('v-main',[_c('div',{staticClass:"text-center"},[(_vm.showLoading)?_c('v-progress-circular',{staticClass:"mx-auto my-15",attrs:{"size":70,"width":7,"color":"purple","indeterminate":""}}):_vm._e()],1),_c('router-view')],1),(_vm.$route.name !== 'approve')?_c('footerBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }